import dayjs, { Dayjs } from "dayjs";

const MONTH_KEYS = [
  "appointments_months_Jan",
  "appointments_months_Feb",
  "appointments_months_Mar",
  "appointments_months_Apr",
  "appointments_months_May",
  "appointments_months_Jun",
  "appointments_months_Jul",
  "appointments_months_Aug",
  "appointments_months_Sep",
  "appointments_months_Oct",
  "appointments_months_Nov",
  "appointments_months_Dec",
];

// Fixed Jan–Dec of the current year, in calendar order. Previously this was a
// rolling 11-month window (5 back → current → 5 forward), which dropped one of
// the calendar months (e.g. December when viewing from June). Each option
// filters its month within the year of the supplied currentDate.
//
// EN-5191: `id` is the stable identity — it is what the selected-filter state carries and what
// the buttons compare against — and `labelKey` is what the reader sees. The two used to be one
// `dayjs().format("MMM")` string, which is neither translated nor stable across dayjs locales.
export const calendarDateFilterOptions = Array.from(
  { length: 12 },
  (_, monthIndex) => ({
    id: dayjs().month(monthIndex).format("MMM"),
    labelKey: MONTH_KEYS[monthIndex],
    value: (currentDate: Dayjs) =>
      currentDate.month(monthIndex).startOf("month"),
  })
);
